import React, { useState, useContext, useEffect, useCallback, useRef, ReactNode } from 'react';

import { getGamesRequest, postAnalytics } from '../../httpRequests/consoleRequests';
import IGame from '../../interfaces/game';
import classes from './gamesHiveBackground.module.scss'
import classNames from 'classnames';

function GamesHiveBackground( { rightInBottom, onGameClicked, children}: {rightInBottom?: boolean, onGameClicked: (game: IGame) => void, children: ReactNode}) {
    const [games, setGames] = useState<Array<IGame>>([])
    useEffect(() => {
        getAvailableGames()
    }, [])
    const handleGameClicked = (game: IGame) => {
        onGameClicked(game)
    }
    const getAvailableGames = async () => {
        const rolloutStorage = localStorage.getItem('rollout')

        const data : Array<IGame> = await getGamesRequest()
        const filteredGames = data.filter(game => rolloutStorage === "testing" ? true : (game.rollout === 'production' && !game.earlyAccess))
        setGames(filteredGames)
      }
      const GameGif = ({index, gameKey}:{index: number, gameKey: IGame['key']}) => {
        const game = games.find(game => game.key === gameKey)
        if (!game) return null

        return (
            <img style={{animationDelay: (0.1 * index).toString() + 's'}} onClick={() => handleGameClicked(game)} className={classes.gif} src={game.gif || '/gifs/' + game.key + '.gif'} />
        )
    }
  return (
    <>
               { 
            games.length > 3 && 
            <div className={classNames(classes.gifRowsRight, {[classes.bottom]: rightInBottom})}>
                <div className={classes.gifRowRight}>
                    <GameGif index={1} gameKey="roperage"/>
                    <GameGif index={0} gameKey="minigames"/>
                </div>
                <div className={classes.gifRowRight}>
                    <GameGif index={4} gameKey="drawgame"/>
                    <GameGif index={3} gameKey="testgamelocal"/>
                    <GameGif index={2} gameKey="icehocky"/>
                </div>
                <div className={classes.gifRowRight}>
                    <GameGif index={6} gameKey="racegame"/>
                    <GameGif index={5} gameKey="cookoff"/>
                </div>
            </div>
        }
        { 
            games.length >= 3 &&
            <div className={classes.gifRowsLeft}>
                <div className={classes.gifRowLeft}>
                    <GameGif index={0} gameKey="cookoff"/>
                </div>
                <div className={classes.gifRowLeft}>
                    <GameGif index={2} gameKey="racegame"/>
                    <GameGif index={1} gameKey="ballfrenzy"/>

                </div>
                <div className={classes.gifRowLeft}>
                    <GameGif index={3} gameKey="icehocky"/>
                </div>
            </div>
        }
        {children}
    </>
  );
}

export default GamesHiveBackground;
